export default "__VITE_ASSET__BJKFgzuQ__"